import { invert } from 'lodash';
import { mainReactionCode } from '../default-reactions';
import { ReactionCodeValue } from '../constants';
const reactionNameToCodeMap = {
    angry: ReactionCodeValue.ANGRY,
    clap: ReactionCodeValue.CLAP,
    surprised: ReactionCodeValue.WOW,
    thinking: ReactionCodeValue.THINKING,
    lol: ReactionCodeValue.HAHA,
    heart: ReactionCodeValue.LOVE,
    thumbsup: ReactionCodeValue.THUMBS_UP,
    sad: ReactionCodeValue.SAD,
    smiley: ReactionCodeValue.SMILE,
};
const reactionCodeToNameMap = invert(reactionNameToCodeMap);
// Main reaction code doesn't change even if the main reaction name changes. This way we preserve data on reconfiguration
export const getReactionCode = (reactionName, mainReactionName) => {
    if (reactionName === mainReactionName) {
        return mainReactionCode;
    }
    return reactionNameToCodeMap[reactionName];
};
export const getReactionCodeByName = (reactionName) => reactionNameToCodeMap[reactionName];
export const getReactionName = (reactionCode, mainReactionName) => {
    if (reactionCode === mainReactionCode) {
        return mainReactionName;
    }
    return reactionCodeToNameMap[reactionCode];
};
export const isValidReactionCode = (reactionCode) => Object.values(ReactionCodeValue).includes(reactionCode);
export const isValidEmotionName = (reactionName) => ['heart', 'thumbsup'].includes(reactionName);
export const getMainEmotionName = (reactionName) => isValidEmotionName(reactionName) ? reactionName : 'heart';
//# sourceMappingURL=reaction-converters.js.map